import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { QueryBuilderModule } from "angular2-query-builder";
import { ChartsModule } from "ng2-charts";
import { ClipboardModule } from "ngx-clipboard";
import { AuthenticationService } from "./authentication/authentication.service";
import { AuthGuard } from "./guards/auth.guard";
import { EncodeHttpParamsInterceptor } from "./interceptors/encode-http-params.interceptor.service";
import { INTERCEPTOR_PROVIDERS } from "./interceptors/interceptor.config";
import { LoadingService } from "./loader/loading.service";
import { LocaleService } from "./locale/locale.service";
import { MaterialModule } from "./material/material.module";

@NgModule({
  declarations: [],
  imports: [
    MaterialModule,
    // Others (Angular, Third Party Modules)
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    DragDropModule,
    QueryBuilderModule,
    ChartsModule,
    RouterModule,
    ClipboardModule,
  ],
  exports: [
    MaterialModule,
    // Others (Angular, Third Party Modules)
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    DragDropModule,
    QueryBuilderModule,
    ChartsModule,
    RouterModule,
    ClipboardModule,
  ],
  providers: [
    AuthenticationService,
    AuthGuard,
    INTERCEPTOR_PROVIDERS,
    LoadingService,
    {
      provide: APP_INITIALIZER,
      useFactory: (localeService: LocaleService) => () => localeService.setDefaultTimezone(),
      deps: [LocaleService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {}
